import React, { useState } from 'react';

const defaultSettings = {
  showFiltersByDefault: true,
  itemsPerPageDefault: 10,
  pageSizeOptions: [5, 10, 20, 50],

  enablePDFExport: true,
  enableExcelExport: true,
  enableCSVExport: true,

  datePresets: {
    today: true,
    yesterday: true,
    last7: true,
    last30: true,
    thisMonth: true,
    lastMonth: true,
    custom: true,
  },

  vehicleTypes: ['JCB', 'Poklaine', 'Tipper'],
  vehicleProviders: ['Own', 'Rent'],
  supervisors: ['Selva', 'Kumar', 'Raj', 'Sekar', 'Jana', 'Sathik', 'Saran', 'Vignesh', 'Sudha'],

  tipperFieldsEnabled: true,
  readingFieldsEnabled: true,
};

const ChipList = ({ items, onRemove }) => (
  <div className="flex flex-wrap gap-2">
    {items.map((item) => (
      <span key={item} className="inline-flex items-center gap-2 rounded border px-2 py-1">
        {item}
        <button onClick={() => onRemove(item)} className="text-red-600" title="Remove">×</button>
      </span>
    ))}
  </div>
);

const AddInline = ({ placeholder, onAdd }) => (
  <div className="flex items-center gap-2">
    <input
      type="text"
      placeholder={placeholder}
      className="rounded-md border px-3 py-2"
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          const val = e.currentTarget.value.trim();
          if (val) onAdd(val);
          e.currentTarget.value = '';
        }
      }}
    />
    <button
      className="px-3 py-2 rounded-md border hover:bg-gray-50"
      onClick={(e) => {
        const input = e.currentTarget.previousSibling;
        if (input && input.value.trim()) {
          onAdd(input.value.trim());
          input.value = '';
        }
      }}
    >Add</button>
  </div>
);

const TransportSettings = () => {
  const [settings, setSettings] = useState(defaultSettings);
  const [saving, setSaving] = useState(false);

  const update = (key, value) => setSettings((s) => ({ ...s, [key]: value }));
  const togglePreset = (key) => update('datePresets', { ...settings.datePresets, [key]: !settings.datePresets[key] });

  const addUnique = (listKey, value) => {
    update(listKey, Array.from(new Set([...(settings[listKey] || []), value])));
  };
  const removeItem = (listKey, value) => {
    update(listKey, (settings[listKey] || []).filter((v) => v !== value));
  };

  const addPageSize = (n) => {
    const num = Number(n);
    if (!Number.isFinite(num) || num <= 0) return;
    const next = Array.from(new Set([...(settings.pageSizeOptions || []), num])).sort((a, b) => a - b);
    update('pageSizeOptions', next);
  };
  const removePageSize = (n) => update('pageSizeOptions', (settings.pageSizeOptions || []).filter((v) => v !== n));

  const onReset = () => setSettings(defaultSettings);

  const onSave = async () => {
    setSaving(true);
    try {
      // Replace with API call to persist settings
      await new Promise((r) => setTimeout(r, 600));
      // eslint-disable-next-line no-console
      console.log('Transport settings saved:', settings);
      alert('Transport settings saved');
    } catch (e) {
      alert('Failed to save Transport settings');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="space-y-6">
      <h2 className="text-xl font-semibold">Transport Settings</h2>


      <div className="rounded-lg border p-4 bg-white space-y-4">
        <h3 className="font-medium text-gray-900">Lists</h3>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <div className="space-y-2"><div className="text-sm text-gray-600">Vehicle Types</div><ChipList items={settings.vehicleTypes} onRemove={(item) => removeItem('vehicleTypes', item)} /><AddInline placeholder="Add vehicle type" onAdd={(val) => addUnique('vehicleTypes', val)} /></div>
       
          
        </div>
      </div>

    
      <div className="flex items-center gap-3">
        <button onClick={onSave} disabled={saving} className={`px-4 py-2 rounded-md text-white ${saving ? 'bg-primary/70' : 'bg-primary hover:opacity-90'}`}>{saving ? 'Saving...' : 'Save Settings'}</button>
        <button onClick={onReset} disabled={saving} className="px-4 py-2 rounded-md border hover:bg-gray-50">Reset to Defaults</button>
      </div>
    </div>
  );
};

export default TransportSettings;


